<script setup lang="ts">
import { computed } from 'vue'

const props = withDefaults(defineProps<{
  modelValue?: [string, string] | string[] | null
  placeholder?: [string, string]
  disabled?: boolean
  ariaLabel?: string
}>(), {
  modelValue: () => ['', ''],
  placeholder: () => ['开始日期', '结束日期'],
  disabled: false,
})

const emit = defineEmits<{
  'update:modelValue': [value: [string, string] | null]
  change: [value: [string, string] | null]
}>()

const value = computed({
  get: () => props.modelValue && props.modelValue.length ? props.modelValue : null,
  set: (next: [string, string] | null) => emit('update:modelValue', next),
})

function onChange(next: [string, string] | null): void {
  emit('change', next)
}
</script>

<template>
  <el-date-picker
    v-model="value"
    class="pro-date-range"
    type="daterange"
    value-format="YYYY-MM-DD"
    range-separator="至"
    :start-placeholder="placeholder[0]"
    :end-placeholder="placeholder[1]"
    :disabled="disabled"
    :aria-label="ariaLabel"
    :clearable="true"
    :teleported="true"
    unlink-panels
    @change="onChange"
  />
</template>

<style scoped>
.pro-date-range { width: 100%; }
</style>
